/**
 * REM 自适应插件（替代 Nuxt plugins/rem.client.ts）
 * 纯 JS，在 main.ts 中 import 即可执行
 */
const docEl = document.documentElement
let isInitialized = false

function refreshRem(designWidth = 750, maxWidth = 750) {
    try {
        const width = Math.min(docEl.getBoundingClientRect().width, maxWidth)
        const rem = (width * 100) / (designWidth / 2)

        const currentRem = parseFloat(getComputedStyle(docEl).fontSize)
        if (!isInitialized || Math.abs(currentRem - rem) > 0.1) {
            docEl.style.fontSize = rem + 'px'
            docEl.style.setProperty('font-size', rem + 'px', 'important')
            docEl.style.setProperty('--base-font-size', rem + 'px')
        }
        isInitialized = true
    } catch (error) {
        console.error('[REM] Error:', error)
    }
}

// 立即执行
refreshRem()

// 监听窗口大小变化（节流 300ms）
let resizeTimer: ReturnType<typeof setTimeout>
window.addEventListener('resize', () => {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(() => refreshRem(), 300)
}, { passive: true })

// 从 bfcache 恢复时重新计算
window.addEventListener('pageshow', (e) => {
    if (e.persisted) refreshRem()
}, { passive: true })

// 设置 body 字体
if (document.readyState === 'complete' || document.readyState === 'interactive') {
    document.body && (document.body.style.fontSize = '16px')
} else {
    document.addEventListener('DOMContentLoaded', () => {
        document.body && (document.body.style.fontSize = '16px')
    }, { once: true })
}

// HMR 热更新支持（Vite 特有）
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        if (!isInitialized) refreshRem()
    })
}
